/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'More2': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.876 17a1.875 1.875 0 11-.001-3.751 1.875 1.875 0 010 3.751zm0-5.625a1.875 1.875 0 11-.001-3.751 1.875 1.875 0 010 3.751zm0-5.625A1.875 1.875 0 119.875 2a1.875 1.875 0 010 3.75z" _fill="#fff"/>'
  }
})
